var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/Note"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_x2F_Note"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Edit"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stroke_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.9999 21.2H13.6999C13.2999 21.2 12.8999 20.9 12.8999 20.4C12.8999 19.9 13.1999 19.6 13.6999 19.6H20.9999C21.3999 19.6 21.7999 19.9 21.7999 20.4C21.7999 20.9 21.3999 21.2 20.9999 21.2Z",
    fill: "#8395A7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Stroke_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.89988 21.2C3.59988 21.2 3.29988 21 3.19988 20.6L2.39988 17.1C2.19988 16.4 2.39988 15.6 2.89988 15.1L12.2999 3.30001C13.2999 2.10001 15.1999 1.90001 16.4999 2.90001C16.5999 3.00001 18.1999 4.20001 18.1999 4.20001C18.7999 4.60001 19.2999 5.20001 19.4999 6.00001C19.6999 6.80001 19.4999 7.50001 19.0999 8.20001C19.0999 8.20001 18.9999 8.30001 9.49988 20.2C8.99988 20.8 8.39988 21.1 7.59988 21.1L3.89988 21.2ZM13.3999 4.30001L3.89988 16C3.69988 16.2 3.69988 16.5 3.69988 16.8L4.39988 19.7H7.39988C7.69988 19.7 8.09988 19.3 8.09988 19.3C8.09988 19.3 17.3999 7.60001 17.5999 7.40001C17.7999 7.10001 17.931 6.87385 17.831 6.47385C17.731 6.07385 17.5417 5.98695 16.9999 5.50001C16.4227 5.02476 15.9085 4.63091 15.1999 4.10001C14.4912 3.56912 13.8999 3.70001 13.3999 4.30001Z",
    fill: "#8395A7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Stroke_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.5863 10.9C16.4084 10.9 16.3195 10.7985 16.1416 10.6971L11.25 6.4348C10.9832 6.13035 10.8943 5.72443 11.1611 5.3185C11.4279 4.91257 11.7837 4.91257 12.1394 5.21701L17.031 9.47927C17.2978 9.78372 17.3867 10.1896 17.1199 10.5956C16.9421 10.7985 16.7642 10.9 16.5863 10.9Z",
    fill: "#8395A7"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.3fa817bed50e3e51dfc7d42f95eadd99.svg";
export { ForwardRef as ReactComponent };